/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Controllers.PostPurchaseTrackingClaimSubmission = class PostPurchaseTrackingClaimSubmission {
  constructor(el) {
    this._requestSuccess = this._requestSuccess.bind(this);
    this._requestFailed = this._requestFailed.bind(this);
    this._updateButton = this._updateButton.bind(this);
    this.el = el;
    this.pb = new Buyapowa.Helpers.ProgressButton(this.el.find('button[data-button]'));
    this.view = new Buyapowa.Views.PostPurchaseTrackingClaimSubmission(this.el, this);
    this.view.onFieldChange(this._updateButton);
  }

  claimButtonClicked() {
    this.view.disableButton();
    return $.ajax({
      method: 'post',
      url: this.view.getUrl(),
      data: this.view.getData()
    }).done(this._requestSuccess).fail(this._requestFailed);
  }

  previouslySubmitted() {
    if (this.view.allFieldsValid()) { return this.view.redirectToFriendConfirmationPage(); }
  }

  _requestSuccess() {
    return this.view.redirectToFriendConfirmationPage();
  }

  _requestFailed() {
    return this.pb.finished(false, this.view.failureText());
  }

  _updateButton() {
    if (this.view.allFieldsValid()) {
      return this.view.enableButton();
    } else {
      return this.view.disableButton();
    }
  }
};

